import { TryFreeButton } from './TryFreeButton.js'

type LandingFooterCtaProps = {
  loading: boolean
  onTryFree: () => void
}

export function LandingFooterCta({ loading, onTryFree }: LandingFooterCtaProps) {
  return (
    <section className="relative border-t border-border overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 bg-[linear-gradient(180deg,hsl(var(--background))_0%,hsl(var(--accent))_100%)]"
      />
      <div aria-hidden className="absolute inset-0 grain opacity-50 pointer-events-none" />
      <div className="relative max-w-3xl mx-auto px-4 py-16 sm:py-20 text-center space-y-6">
        <h2 className="text-2xl sm:text-3xl font-bold tracking-tight">
          今日の素材から、送ってみませんか
        </h2>
        <p className="text-muted-foreground">アカウント登録は、あとからでも大丈夫です。</p>
        <TryFreeButton loading={loading} onTryFree={onTryFree} />
      </div>
    </section>
  )
}
